// extracted by mini-css-extract-plugin
module.exports = {"content":"_13pTf7BcR4_calculator","full-screen":"_2MAaPBMRhs_calculator","curtain":"_1O0Hm3nluv_calculator","container":"_1KSBe2SMHV_calculator","sticky":"_1_OZT72kdG_calculator"};